import keyBy from 'lodash/keyBy';

export default function updateProperties(
    {properties}: UpdateAreaPropertiesAction,
    setAreas: SetState<{[localId: string]: Area}>
) {
    const data = Array.isArray(properties) ? properties : [properties];

    setAreas((latestAreas) => {
        const updates = data.map((areaProperties: PartialAreaProperties) => ({
            ...latestAreas[areaProperties.localId],
            properties: {
                ...latestAreas[areaProperties.localId].properties,
                ...areaProperties,
            },
        }));

        return {
            ...latestAreas,
            ...keyBy(updates, (area) => area.properties.localId),
        };
    });

    return data.map((areaProperties) => areaProperties.localId);
}
